// Token
export const KEY_CODE = 'code'
export const KEY_ACCESS = 'accessToken'
export const KEY_REFRESH = 'refreshToken'

//language
export const LANGUAGE = {
    EN: 'en',
    JP: 'jp',
}
